export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";